// extracted by mini-css-extract-plugin
export default {"container":"heritage_container__01TTB","row":"heritage_row__RT9BX","image":"heritage_image__konE3"};